var React = require('react');

function YoutubeLogo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"youtube-54"),React.createElement("path",{"d":"M524.42,859.1l-204.18-3.74c-66.11-1.3-132.39,1.3-197.2-12.18C24.44,823,17.45,724.27,10.14,641.43.07,525,4,406.38,23,290.89c10.73-64.81,53-103.48,118.25-107.69,220.43-15.27,442.33-13.46,662.27-6.33,23.23.65,46.61,4.22,69.52,8.28,113.06,19.82,115.82,131.74,123.15,226a1280.79,1280.79,0,0,1-9.75,285.4c-11.21,78.28-32.65,143.92-123.15,150.26-113.38,8.28-224.17,15-337.87,12.83C525.4,859.1,524.75,859.1,524.42,859.1Zm-120-198.18c85.45-49.06,169.26-97.3,254.22-146-85.6-49.06-169.26-97.3-254.22-146Z","transform":"translate(-4.75 -171.55)","fill":"#ffff","key":1})]);
}

YoutubeLogo.defaultProps = {"viewBox":"0 0 995.25 688.45"};

module.exports = YoutubeLogo;

YoutubeLogo.default = YoutubeLogo;
